<div class="introduction-container w-100" style="position: relative">
  <div class="d-flex justify-content-center introduction-center">
    <div class="card introduction-card" [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [style.border-color]="clozeTestStyleModel().frameColor" [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '8px',
        width: mobileMode() ? '' : '720px',
      }">

      <div class="card-body introduction-card-body" [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="clozeTestStyleModel().fontSize">

        @if (!mobileMode()) {
        <div class="card-title-row">
          @if (lang().toLowerCase() === 'de') {
          <h4 class="card-title">Hinweise zu den Lückentexten</h4>
          } @else {
          <h4 class="card-title">Hints for the c-test</h4>
          }
        </div>
        }

        @if (mobileMode()) {
        <div class="card-title-row">
          @if (lang().toLowerCase() === 'de') {
          <h4 class="card-title">Hinweise zum Test</h4>
          } @else {
          <h4 class="card-title">Hints for the test</h4>
          }
        </div>
        } @else {
        @if (lang().toLowerCase() === 'de') {
        <h6 class="card-subtitle mb-2 text-muted text-center">Bitte aufmerksam lesen. Die Zeit läuft noch nicht.</h6>
        } @else {
        <h6 class="card-subtitle mb-2 text-muted text-center">Please read carefully. The time is not running yet.</h6>
        }
        }

        @if (mobileMode()) {
        <div>
          <div class="mt-4 instruction-container">
            <img alt="Onset Test Logo" class="instruction-icon" src="onset-assets/img/onSET_Text.svg" />
            @if (lang().toLowerCase() === 'de') {
            <span class="instruction-text">In den folgenden Texten fehlen bei vielen Wörtern einige Buchstaben. Schreiben Sie die fehlenden Buchstaben in die Lücken.</span>
            } @else {
            <span class="instruction-text">In the following texts, some letters are missing in a number of words. Please fill the gaps by completing these words.</span>
            }
          </div>
          <div class="mt-4 instruction-container">
            <img alt="Testzeit-Logo" class="instruction-icon" src="onset-assets/img/onSET_Zeit.svg" />
            @if (lang().toLowerCase() === 'de') {
            <span class="instruction-text">Sie haben für jeden Text 5 Minuten Zeit.</span>
            } @else {
            <span class="instruction-text">You have a maximum of 5 minutes for each text.</span>
            }
          </div>
          <div class="mt-4 instruction-container">
            <img alt="Auszeit-Logo" class="instruction-icon" src="onset-assets/img/onSET_Zeit_fertig.svg" />
            @if (lang().toLowerCase() === 'de') {
            <span class="instruction-text">Nach Ablauf der Zeit werden Sie automatisch zum nächsten Text weitergeleitet. Sollten Sie schneller fertig sein, tippen Sie auf „Fertig", dann auf „Weiter".</span>
            } @else {
            <span class="instruction-text">After 5 minutes, you will automatically be forwarded to the next text. Your final 60 seconds will be displayed before you are sent to the next text.</span>
            }
          </div>
          <div class="mt-4 instruction-container">
            <img alt="Logo der Endbearbeitung" class="instruction-icon" src="onset-assets/img/onSET_Text_beenden.svg" />
            @if (lang().toLowerCase() === 'de') {
            <span class="instruction-text">Der Test endet nach dem letzten Text oder wenn Sie auf „Test beenden" tippen.</span>
            } @else {
            <span class="instruction-text">The test is finished once the 5 minutes of the final text are over, or when you click on "Finish the test".</span>
            }
          </div>
        </div>
        }

        <br />

        @if (!mobileMode()) {
        @if (lang().toLowerCase() === 'de') {
        <div class="card-text mb-4">
          <p>In den folgenden Texten fehlen bei einer Reihe von Wörtern jeweils einige Buchstaben. Ergänzen Sie bitte
            die Lücken in sinnvoller Weise. Sie haben für jeden Text maximal 5 Minuten Zeit.</p>
          <p>Brauchen Sie Umlaute (ä, ö, ü) und finden Sie diese nicht auf Ihrer Tastatur, klicken Sie einfach auf den
            richtigen Umlaut im Fenster unten. Verwenden Sie keine Kombination wie "ae" oder "ue" oder "oe".</p>
          <p>Sollten Sie vor Ablauf der 5 Minuten mit einem Text fertig sein, kommen Sie zum nächsten Text, indem Sie
            zuerst "Text fertig bearbeitet" markieren und dann "Weiter zum nächsten Text" klicken.</p>
          <p>Dieser Teil ist beendet, wenn Sie den letzten Text 5 Minuten lang bearbeitet haben oder auf "Test beenden"
            klicken.</p>
          <p>Klicken Sie nun auf "Test starten", um den ersten Text zu bearbeiten.</p>
        </div>
        } @else {
        <div class="card-text mb-4">
          <p>In the following texts, several letters are missing from a number of words. Please fill in the gaps in a
            meaningful way. You have a maximum of 5 minutes for each text.</p>
          <p>If you are finished with a text before the 5 minutes have elapsed, you come to the next text, by first
            marking "Text completed" and then clicking "Next".</p>
          <p>This part is finished when you have edited the last text for 5 minutes or click "End test".</p>
          <p>Now click on "Start test" to edit the first text.</p>
        </div>
        }
        }

        <div class="text-center">
          @if (!mobileMode()) {
          <button class="btn" style="font-size: smaller" [style.background-color]="cTestButtonColor()"
            (click)="toggleStartTest()">
            {{ lang().toLowerCase() === 'de' ? 'TEST STARTEN' : 'START TEST' }}
          </button>
          }
          @if (mobileMode()) {
          @if (lang().toLowerCase() === 'de') {
          <p style="text-align: start">Tippen Sie jetzt auf "Beispiel starten", um sich mit dem Test vertraut zu machen.</p>
          } @else {
          <p style="text-align: start">Now click on "Start example" in order to get familiar with the test.</p>
          }
          <button class="btn" style="font-size: smaller" [style.background-color]="cTestButtonColor()"
            (click)="toggleStartTestExample()">
            {{ lang().toLowerCase() === 'de' ? 'BEISPIEL STARTEN' : 'START EXAMPLE' }}
          </button>
          }
        </div>

      </div>
    </div>
  </div>
</div>
